export default {
  taxData: {
    data: [],
    pagination: {
      total: 0
    }
  }
}
